import { BoldText } from "components/BoldText/BoldText";

import styles from "../styles.module.scss";

export const Header = () => (
  <BoldText className={styles.groupTitle}>Группы товаров</BoldText>
);
